module.exports = __webpack_public_path__ + "img/ky.cdb2b536.svg";